module.exports = __webpack_public_path__ + "img/20200808_150333.a32cdb26.jpg";